export function waitForScrollStop () {
  return new Promise((resolve) => {
    let eventHandler
    let isScrollingTimeout

    const scrollStopped = () => {
      window.removeEventListener('scroll', eventHandler, false)
      resolve()
    }

    eventHandler = () => {
      window.clearTimeout(isScrollingTimeout)
      isScrollingTimeout = setTimeout(scrollStopped, 100)
    }

    isScrollingTimeout = setTimeout(scrollStopped, 100)
    window.addEventListener('scroll', eventHandler, false)
  })
}



// WEBPACK FOOTER //
// ./src/lib/scrollStop.js